module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.loading) ? _c('loading') : _c('div', {
    staticClass: "page-view--assignment"
  }, [_c('header', {
    staticClass: "page-header assignment-header"
  }, [_c('router-link', {
    staticClass: "back tag button-timid left button-backward",
    attrs: {
      "to": _vm.returnLink.route
    }
  }, [_vm._v(_vm._s(_vm.returnLink.name))]), _c('a', {
    staticClass: "assignment-goals tag button-timid right",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showGoals(_vm.assignment)
      }
    }
  }, [_vm._v("Doelstellingen")]), _c('h1', [_c('span', {
    staticClass: "assignment-icon",
    class: _vm.type_class
  }), _vm._v(" " + _vm._s(_vm.assignment.title))]), _c('progress-bar', {
    attrs: {
      "assignment": _vm.assignment,
      "steps": _vm.steps,
      "progress": _vm.progress,
      "current-step": _vm.currentStepIdx
    }
  }), _c('hr')], 1), _c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "after-enter": _vm.viewChange
    }
  }, [_c('router-view', {
    key: _vm.$route.params.stepIdx,
    attrs: {
      "assignment": _vm.assignment,
      "steps": _vm.steps,
      "progress": _vm.progress,
      "group": _vm.group,
      "isInspectingStudent": _vm.isInspectingStudent,
      "isInspecting": _vm.isInspecting,
      "isReviewing": _vm.isReviewing,
      "user": _vm.user,
      "returnLink": _vm.returnLink
    }
  })], 1), (_vm.isReviewing) ? _c('teacher-feedback', {
    attrs: {
      "assignment": _vm.assignment,
      "progress": _vm.progress,
      "group": _vm.group,
      "isDemo": _vm.isDemo,
      "reviewee": _vm.user,
      "returnLink": _vm.returnLink
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-96ac77a4","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/assignment/Assignment.vue
// module id = zu0v
// module chunks = 1